// import { url } from "inspector"
import elisa from "../assets/data/ELISA.json"
import sh from "../assets/data/sh.json"
const getImageUrl = (name) => {
  // 使用 new URL 动态构建 URL
  return new URL(name, import.meta.url).href;
};

export const wxIng = getImageUrl('/images/assets/wx.jpg')
export const logoJpg = getImageUrl('/ymz.jpg')
const elisa_imgs = [
  getImageUrl('/images/assets/elisa/284A7110.jpg'),
  getImageUrl('/images/assets/elisa/284A7111.jpg'),
  getImageUrl('/images/assets/elisa/284A7112.jpg'),
  getImageUrl('/images/assets/elisa/284A7113.jpg'),
  getImageUrl('/images/assets/elisa/284A7114.jpg'),
  getImageUrl('/images/assets/elisa/284A7115.jpg'),
  getImageUrl('/images/assets/elisa/284A7116.jpg'),
  getImageUrl('/images/assets/elisa/284A7117.jpg'),
  getImageUrl('/images/assets/elisa/284A7118.jpg'),
  getImageUrl('/images/assets/elisa/284A7119.jpg'),
  getImageUrl('/images/assets/elisa/284A7120-2.jpg'),
  getImageUrl('/images/assets/elisa/284A7121.jpg'),
  getImageUrl('/images/assets/elisa/284A7122.jpg'),
  getImageUrl('/images/assets/elisa/284A7123.jpg'),
  getImageUrl('/images/assets/elisa/284A7127.jpg'),
]
const elisa_imgs1 = [
  getImageUrl('/images/assets/elisa1/elisa-1.jpg'),
  getImageUrl('/images/assets/elisa1/elisa-2.jpg'),
  getImageUrl('/images/assets/elisa1/elisa-3.jpg'),
  getImageUrl('/images/assets/elisa1/elisa-4.jpg'),
  getImageUrl('/images/assets/elisa1/elisa-5.jpg'),
  getImageUrl('/images/assets/elisa1/elisa-6.jpg'),
]
const sh_imgs = [
  getImageUrl('/images/assets/sh/284A7096.jpg'),
  getImageUrl('/images/assets/sh/284A7097.jpg'),
  getImageUrl('/images/assets/sh/284A7101.jpg'),
  getImageUrl('/images/assets/sh/284A7104.jpg'),
  getImageUrl('/images/assets/sh/284A7108.jpg'),
  getImageUrl('/images/assets/sh/284A7109.jpg'),
]
const sh_imgs1 = [
  getImageUrl('/images/assets/sh1/sh1.jpg'),
  getImageUrl('/images/assets/sh1/sh2.jpg'),
]
function getRandomImages(images, count = 1, minIndex = 0, maxIndex) {
  if (!Array.isArray(images) || images.length === 0 || count <= 0) {
    return []
  }
  const lastIndex = images.length - 1
  const actualMaxIndex = maxIndex !== undefined ?
    Math.min(maxIndex, lastIndex) :
    lastIndex


  if (minIndex < 0 || minIndex > actualMaxIndex) {
    minIndex = 0
  }


  const result = []
  for (let i = 0; i < count; i++) {
    const randomIndex = Math.floor(Math.random() * (actualMaxIndex - minIndex + 1)) + minIndex
    result.push(images[randomIndex])
  }
  return result
}
export const elisa_imgs_obj = () => {
  return getRandomImages(elisa_imgs, 1, 0, 14)
}
export const elisa1_imgs_obj = () => {
  return getRandomImages(elisa_imgs1, 1, 0, 5)
}
export const sh_imgs_obj = () => {
  return getRandomImages(sh_imgs, 1, 0, 5)
}
export const sh1_imgs_obj = () => {
  return getRandomImages(sh_imgs1, 1, 0, 1)
}
export const banner = [
  {
    id: 1,
    image: elisa1_imgs_obj(),
    title: 'ELISA',
    description: '专注细胞因子、抗体、ELISA试剂盒研发生产',
    link: '/category'
  },
  {
    id: 2,
    image: sh1_imgs_obj(),
    title: '生化',
    description: '专注细胞因子、抗体、ELISA试剂盒研发生产',
    link: '/category'
  },
]
// elisa数据
export const elisaFunc = () => {
  let obj = JSON.parse(JSON.stringify(elisa))
  return obj.ymz
}
// sh数据
export const shFunc = () => {
  let obj = JSON.parse(JSON.stringify(sh))
  return obj['产品目录']
}
export const getProductsByCategory = (params) => {
  let arr1 = elisaFunc().map((item) => {
    return {
      ...item,
      category: "ELISA",
      image: elisa_imgs_obj()[0],
      proNum: item.proNum,
      spec: item.spec,
      originalPrice: "¥1,500-¥3,000",
      minPrice: 1500,
      maxPrice: 2400
    };
  });
  let arr2 = shFunc().map((item) => {
    return {
      ...item,
      category: "SH",
      image: sh_imgs_obj()[0],
      proNum: item.proNum,
      spec: item.spec,
      originalPrice: item.price + 100,
      minPrice: item.price,
      maxPrice: item.price + 100,
    };
  });
  let arr = [...arr1, ...arr2]
  // 分类筛选
  // if(params){
  //   arr = arr.filter(item=>item.category === params.category)
  // }
  return arr
}
// 详情数据
export const getData = (list, proNum) => {
  return list.filter(item => item.proNum === proNum)
}
// 分类筛选
export const getCategory = (list, category) => {
  return list.filter(item => item.category === category)
}
// 价格筛选
export const getDataByPrice = (products, targetSpecs) =>{
    // 创建正则表达式，匹配任意一个目标规格
  // \b 表示单词边界，确保匹配完整数字
  const pattern = new RegExp(`\\b(${targetSpecs.join('|')})\\b`, 'i');
  
  return products.filter(product => {
    // 检查规格字符串是否存在并匹配
    return product.spec && pattern.test(product.spec);
  });
}
// 规格筛选
export const category = [
  {
    id: 0,
    name: '全部',
    image: elisa1_imgs_obj(),
    description: '多种物种和检测目标',
    count: 1950,
    slug: 'ALL'
  },
  {
    id: 1,
    name: 'ELISA',
    image: elisa1_imgs_obj(),
    description: '多种物种和检测目标',
    count: getCategory(getProductsByCategory(), 'ELISA').length,
    slug: 'ELISA'
  },
  {
    id: 2,
    name: '生化',
    image: sh1_imgs_obj(),
    description: '高纯度，高活性',
    count: getCategory(getProductsByCategory(), 'SH').length,
    slug: 'SH'
  },
]

export function convertKeys(arr, keyMap) {
  return arr.map(item => {
    const newObj = {};
    for (const [chineseKey, englishKey] of Object.entries(keyMap)) {
      if (chineseKey in item) {
        newObj[englishKey] = item[chineseKey];
      }
    }
    // 保留未映射的属性
    Object.keys(item).forEach(key => {
      if (!(key in keyMap)) {
        newObj[key] = item[key];
      }
    });
    return newObj;
  });
}

export const elisa_keyMapping = {

}

export const sh_keyMapping = {

}
